module.exports = __webpack_public_path__ + "img/logo.4769d80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo.svg
// module id = qz/U
// module chunks = 1